import { KeyConstant, SystemConstant } from "const";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StorageUtil } from "utils";
import { toCamel } from "utils";
import { getInteractor } from "services/local.service";
import { getAllDeviceFromRemote } from "pubsub/services/device.service";

const useDeviceList = () => {
  const prefixKey = StorageUtil.getCurrentPrefixKey();
  const accountId = StorageUtil.getItem(KeyConstant.KEY_ACCOUNT_ID, prefixKey);
  const deviceId = StorageUtil.getItem(KeyConstant.KEY_DEVICE_ID, prefixKey);

  const fetchStatus = useSelector(state => state.deviceRedux.fetchStatus);

  const [masterDeviceList, setMasterDeviceList] = useState([]);
  const [slaveDeviceList, setSlaveDeviceList] = useState([]);
  const [isMaster, setIsMaster] = useState(false);

  // Query data from local db
  const getDeviceList = async () => {
    let deviceRecords = await getInteractor(prefixKey).LocalDeviceService.getAllByAccount(accountId);

    deviceRecords = toCamel(deviceRecords.filter(s => s.state === 1));
    sortDeviceRecords(deviceRecords);
    setMasterDeviceList(deviceRecords.filter(item => item.masterF === 1));
    setSlaveDeviceList(deviceRecords.filter(item => item.masterF === 0));

    // Check current device is master or not
    const deviceInfo = await getInteractor(prefixKey).LocalDeviceService.get(deviceId);
    if (Boolean(deviceInfo)) {
      setIsMaster(deviceInfo.master_f === SystemConstant.DEVICE_KEY_STATE.correct);
    }
  };

  const sortDeviceRecords = deviceRecords => {
    deviceRecords.sort((rec1, rec2) => {
      switch (true) {
        case rec1.state === SystemConstant.DEVICE_STATE.active && rec2.state === SystemConstant.DEVICE_STATE.inactive:
          return -1;
        case rec1.state === SystemConstant.DEVICE_STATE.inactive && rec2.state === SystemConstant.DEVICE_STATE.active:
          return 1;
        default:
          return rec2.lastSeen - rec1.lastSeen;
      }
    });
  };

  // Call to synch data from server
  const fetchDeviceList = async () => {
    const result = await getAllDeviceFromRemote(prefixKey, accountId);
    if (result) await getDeviceList();
  };

  useEffect(() => {
    getDeviceList();
  }, []);

  useEffect(() => {
    if (fetchStatus > 0) {
      getDeviceList();
    }
  }, [fetchStatus]);

  return { masterDeviceList, slaveDeviceList, isMaster, getDeviceList, fetchDeviceList };
};

export default useDeviceList;
